import { WorkPackageStats, AttendanceGraph, UnitOfMeasure } from '@bechtel/types';

export const dashBoardStatsMock: WorkPackageStats = {
  id: '',
  numBlocks: 0,
  numRejects: 0,
  numWorkPackages: 0,
  plannedToGoMilestones: {
    id: '',
    hours: 0,
    numMilestones: 0,
    quantity: {
      quantity: 0,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  plannedMilestones: {
    id: '',
    hours: 0,
    numMilestones: 0,
    quantity: {
      quantity: 0,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  earnedMilestones: {
    id: '',
    hours: 0,
    numMilestones: 0,
    quantity: {
      quantity: 0,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  approvedMilestones: {
    id: '',
    hours: 0,
    numMilestones: 0,
    quantity: {
      quantity: 0,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  committedMilestones: {
    id: '',
    hours: 0,
    numMilestones: 0,
    quantity: {
      quantity: 0,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
  },
  crew: {
    numCrewMembers: 0,
    numCrews: 0,
    attendanceGraph: AttendanceGraph.SAME,
    attendancePct: 0,
    numCurrentlyOnSite: 0,
  },
  crewMemberId: '',
  progress: {
    id: '',
    crewMemberId: '',
    approvedHours: 0,
    claimedHours: 0,
    committedHours: 0,
    targetHours: 0,
    approvedQuantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
    committedQuantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
    claimedQuantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
    targetQuantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
  },
};
